import { render, staticRenderFns } from "./list-wo-approval.vue?vue&type=template&id=24da6a2c&"
import script from "./list-wo-approval.vue?vue&type=script&lang=js&"
export * from "./list-wo-approval.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports